import React, { useState } from "react";
import { Alert, Text, Group, Button } from "@mantine/core";
import {
  IconAlertTriangle,
  IconChevronDown,
  IconChevronUp,
} from "@tabler/icons-react";
import { useProducts } from "../../context/ProductsContext";

const COLLAPSED_LIMIT = 3;

export default function StockAlertBanner({ onAlertClick }) {
  const { getLowStockProducts } = useProducts();
  const lowStockProducts = getLowStockProducts();
  const [expanded, setExpanded] = useState(false);

  if (lowStockProducts.length === 0) {
    return null;
  }

  const hasMore = lowStockProducts.length > COLLAPSED_LIMIT;
  const visibleProducts = expanded
    ? lowStockProducts
    : lowStockProducts.slice(0, COLLAPSED_LIMIT);

  return (
    <Alert
      icon={<IconAlertTriangle size={16} />}
      title="Low Stock Alert"
      color="var(--brand-burnt-orange)"
      variant="light"
      py="xs"
    >
      <Text size="sm" mb="xs">
        You have low stock for the following products:
      </Text>
      <Group gap="xs" wrap="wrap">
        {visibleProducts.map((product) => (
          <Button
            key={product.id}
            variant="light"
            size="compact-xs"
            color="var(--brand-burnt-orange)"
            onClick={() => onAlertClick(product)}
          >
            {product.name} ({product.quantity} units)
          </Button>
        ))}
        {hasMore && (
          <Button
            variant="subtle"
            size="compact-xs"
            color="var(--brand-burnt-orange)"
            aria-expanded={expanded}
            onClick={() => setExpanded((e) => !e)}
            rightSection={
              expanded ? (
                <IconChevronUp size={12} />
              ) : (
                <IconChevronDown size={12} />
              )
            }
          >
            {expanded
              ? "Show less"
              : `+${lowStockProducts.length - COLLAPSED_LIMIT} more`}
          </Button>
        )}
      </Group>
    </Alert>
  );
}
